export function maskEmail(email: string) {
  const [localPart, domain] = email.split('@');
  const firstChar = localPart.at(0) ?? '';
  const lastChar = localPart.length <= 1 ? '' : (localPart.at(-1) ?? '');

  return `${firstChar}${'*'.repeat(3)}${lastChar}@${domain}`;
}
